import '../css/tw.css';

import Alpine from 'alpinejs'
 
window.Alpine = Alpine

// Add Alpine extensions here
 
Alpine.start()

console.log('hello from index.js')